import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";  

export default function Sikllscategories({ data = {} }) {
  const [Pagetitle, setPagetitleData] = useState('Find the Right Job or Talent Faster');
  const [Pagedescription, setPagedescriptionData] = useState(
    'Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers.'
  );

  useEffect(() => {
    if (data?.title) {
      setPagetitleData(data.title);
    }
    if (data?.description) {
      setPagedescriptionData(data.description);
    }
  }, [data]);

  return (
    <div className="container_roots">
      <Helmet>
        <title>{Pagetitle} | EditorTask - Find the Right Job or Talent Faster</title>

        <meta name="description" content={Pagedescription} />
        <meta
          name="keywords"
          content={`${Pagedescription}, job portal, freelance jobs, editor showcase, hire editors, post jobs, portfolio platform, task marketplace, India jobs, design gigs, video editing work`}
        />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content={`${Pagetitle} | EditorTask - Find the Right Job or Talent Faster`}
        />
        <meta property="og:description" content={Pagedescription} />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={typeof window !== 'undefined' ? window.location.href : 'https://www.editortask.com/'}
        />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
      </Helmet>

      <div className="container_size">
        <p className="contact-title">{Pagetitle}</p>
        <a className="contact-title">{Pagedescription}</a>
      </div>
    </div>
  );
}
